// @flow

import styled, { type StyledComponent } from "styled-components";

import Icon from "app/components/shared/Icon";

type Props = {
  style?: Object,
  className?: string,
  icon?: string,
  title?: string,
  revealed?: boolean,
  strokeWidth?: number,
};

const RevealableDownChevron: StyledComponent<Props, empty, typeof Icon> =
  styled(Icon).attrs({
    icon: "chevron-right",
    revealed: false,
    size: 14,
    strokeWidth: 2,
  })`
    transform: rotate(${(props) => (props.revealed ? -90 : 90)}deg);
    trasform-origin: center 0;
    transition: transform 150ms;
    will-change: transform;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;

    polyline {
      stroke-width: ${(props) => props.strokeWidth}px;
    }
  `;

export default RevealableDownChevron;
